export default "__VITE_ASSET__e7ea9bdd__"